const bcl = window.bcl || {};

bcl.contextHub = {
  props: {
    nameSessionStorage: "contextHub.",
    nameProfile: "profile",
    nameFav: "favorites",
    pending: "pending",
    url: "/bin/barcelo/loadProfile.json",
    stores: {},
    ttl: 10 * 60 * 1000,
    storesPending: {},
    requestsPending: {},
    lasukmybCookie: "lasukmyb",
    lasukmybErrorCookie: "lasukmyb-error",
    loginError: ["inactive-user", "not-userid", "not-useremail", "api-error", "generic-error"],
  },

  init: function () {
    const initRequest = function () {
      const store = bcl.contextHub.get(bcl.contextHub.props.nameProfile);
      bcl.contextHub.makeRequest(store);
    };

    document.readyState !== "loading" ? initRequest() : document.addEventListener("DOMContentLoaded", initRequest);
  },

  makeRequest: function (store, attempt = 0, maxRetries = 5) {
    if (!store) {
      if (this.props.requestsPending[this.props.nameProfile]) {
        return;
      }

      if (!this.validLoginButton()) {
        this.fixLoginButton();
      }

      this.props.requestsPending[this.props.nameProfile] = true;

      bcl.ajax.postRequest({
        url: this.props.url,
        data: {},
        callback: (response) => {
          this.props.requestsPending[this.props.nameProfile] = false;
          bcl.contextHub.handleResponse(response, attempt, maxRetries);
        },
        errorCallback: (first, second) => {
          this.props.requestsPending[this.props.nameProfile] = false;
          const error = first?.status ? first : second;
          const itemCallback = first?.store ? first : second;
          this.handleError(error, itemCallback);
        },
        itemCallback: { store: this.props.nameProfile },
      });
    } else {
      this.executeAllPending(this.props.nameProfile);
    }
  },

  handleError: function (error, obj) {
    const status = error?.status || error?.response?.status || error?.request?.status;

    if (status === 401 || status === 403) {
      this.executeAllPending(obj?.store || this.props.nameProfile);
      return;
    }

    console.error("AJAX error:", error);
    this.executeAllPending(obj?.store || this.props.nameProfile);
  },

  handleResponse: function (response, attempt, maxRetries) {
    if (response && response.status === 200 && response.response) {
      this.getRequest(response, { store: this.props.nameProfile });
    } else if (attempt + 1 < maxRetries) {
      setTimeout(() => {
        bcl.contextHub.makeRequest(null, attempt + 1, maxRetries);
      }, 1000);
    } else {
      console.error(`Failed to load profile after ${maxRetries} attempts.`);
      this.setAnonymousStore({ store: this.props.nameProfile });
    }
  },

  clearLoginSession: function () {
    sessionStorage.removeItem(`${this.props.nameSessionStorage}${this.props.nameProfile}`);
    ["login-token", "bhg-user", "bhg-ciam-user", "ROCP_token", "ROCP_idToken", this.props.lasukmybCookie, this.props.lasukmybErrorCookie].forEach((name) => {
      document.cookie = `${name}=; Max-Age=0; path=/`;
    });
  },

  setAnonymousStore: function (obj) {
    const storeName = obj?.store || this.props.nameProfile;
    const store = {
      ready: true,
      expiry: Date.now() + this.props.ttl,
      user: {},
      props: {},
    };

    sessionStorage.setItem(`${this.props.nameSessionStorage}${storeName}`, JSON.stringify(store));
    this.props.stores[storeName] = store;
    this.executeAllPending(storeName);
  },

  getRequest: function (res, obj) {
    if (!res.response) {
      return;
    }

    const payload = JSON.parse(res.response);
    const edgescape = res.getResponseHeader("X-Akamai-Edgescape") || "";
    if (payload?.federationId) {
      bcl.cookie.set(this.props.lasukmybCookie, "1", { path: "/" });
    }

    const clientIp = res.getResponseHeader("X-Bgh-Client-Ip") || "";

    const store = {
      ready: true,
      expiry: Date.now() + this.props.ttl,
      user: payload,
      props: this.parseResponse(edgescape),
      clientIp: clientIp,
    };

    const key = this.props.nameSessionStorage + (obj && obj.store ? obj.store : this.props.nameProfile);
    sessionStorage.setItem(key, JSON.stringify(store));
    this.props.stores[this.props.nameProfile] = store;
    this.executeAllPending(this.props.nameProfile);
  },

  validLoginButton: function () {
    const cookieName = "mybLoginCleanv4";
    const cookie = document.cookie
      .split(";")
      .map((c) => c.trim())
      .find((c) => c.startsWith(`${cookieName}=`));

    if (!cookie) {
      return false;
    }
    const expires = new Date(decodeURIComponent(cookie.split("=")[1]));
    return !isNaN(expires.getTime()) && expires > new Date();
  },

  fixLoginButton: function () {
    sessionStorage.removeItem(`${this.props.nameSessionStorage}${this.props.nameProfile}`);
    document.cookie = `${this.props.lasukmybErrorCookie}=; Max-Age=0; path=/`;

    const exp = new Date();
    exp.setMonth(exp.getMonth() + 6);
    document.cookie = `mybLoginCleanv4=true; expires=${exp.toUTCString()}; path=/`;
  },

  parseResponse: function (header) {
    return header.split(",").reduce((out, pair) => {
      const [k, v] = pair.split("=");
      if (k && v) {
        out[k] = v;
      }
      return out;
    }, {});
  },

  callWhenReady: function (func, name) {
    if (typeof func !== "function") {
      return false;
    }
    const obj = this.get(name);
    if (obj && obj.ready) {
      func();
    } else {
      this.addPending(name, func);
    }
    return true;
  },

  isEnabled: function () {
    return true;
  },

  get: function (name) {
    let store = this.props.stores[name];
    if (!store) {
      const raw = sessionStorage.getItem(`${this.props.nameSessionStorage}${name}`);
      if (raw) {
        store = JSON.parse(raw);
      }
    }

    if (store) {
      if (store.expiry < Date.now()) {
        delete this.props.stores[name];
        sessionStorage.removeItem(`${this.props.nameSessionStorage}${name}`);
        return null;
      }
      this.props.stores[name] = store;
    }
    return store ?? null;
  },

  getItem: function (store, name) {
    const storeObj = typeof store === "string" ? this.get(store) : store;
    return storeObj?.props?.[name];
  },

  getPending: function (storeName) {
    return (this.props.storesPending[storeName] ||= []);
  },

  addPending: function (storeName, fn) {
    this.getPending(storeName).push(fn);
  },

  executeAllPending: function (storeName) {
    const queue = this.getPending(storeName);
    while (queue.length) {
      const cb = queue.shift();
      cb();
    }
  },
};
